import React from "react";
import { cn } from "../../lib/utils";

export const CompanionFormProgressItem = ({ children, pos, isActive }) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2 transition-opacity duration-300",
        !isActive && "opacity-50"
      )}
    >
      <p
        className={cn(
          "size-8 lg:size-7 rounded-full text-sm font-bold border flex  items-center justify-center text-center focus:outline-none",
          isActive && "ring-2 ring-primary"
        )}
      >
        <span>{pos}</span>
      </p>

      <span className={"hidden lg:inline font-bold"}>{children}</span>
    </div>
  );
};
